<template>
  <v-avatar class="avatar" :size="size" :style="INITIALS_AVATAR_STYLES">
    <v-img v-if="contact.avatar" :alt="contact.displayName" :src="contact.avatar"></v-img>
    <div v-else-if="(contact.initials || '').length" class="avatar-initials">
      {{ contact.initials }}
    </div>
    <v-icon v-else dark :style="ICON_AVATAR_STYLES">mdi-account</v-icon>
  </v-avatar>
</template>

<script>
export default {
  name: 'SmsAvatar',

  props: {
    contact: {
      type: Object,
      default: () => {
        return {};
      }
    },
    size: {
      type: Number,
      default: 32
    }
  },
  computed: {
    INITIALS_AVATAR_STYLES() {
      const avatarColor = this.contact.initials !== ''
        ? this.getColorFromString(this.contact.initials)
        : 'var(--v-secondary)';
      const avatarFontColor = this.contact.initials !== ''
        ? this.getFontColorFromString(this.contact.initials)
        : 'var(--v-secondary-text-color)';

      return {
        backgroundColor: avatarColor,
        color: avatarFontColor,
        fontSize: `${this.size / 2.7}px !important`,
        lineHeight: `${this.size}px`
      };
    },

    ICON_AVATAR_STYLES() {
      return {
        'background-color': this.getColorFromString(this.contact.number)
      };
    }
  },

  methods: {
    _getHueFromString(string = '') {
      let hash = 0;
      for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 20) - hash);
      }
      return hash % 360;
    },

    getColorFromString(string) {
      const saturation = 65;
      const lightness = 70;
      const hue = this._getHueFromString(string);
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    },

    getFontColorFromString(string) {
      const saturation = 65;
      const lightness = 32;
      const hue = this._getHueFromString(string);
      return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
    }
  }
};
</script>

<style scoped>
.avatar {
  background-color: var(--v-info-base);
  color: #fff;
}
.avatar-initials {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
}
</style>
